import { BASE_URI_DEVELOPMENT_CENTER } from '@/api/CONST.js';

/**
 * Получить файл ошибок
 * @param {*} importId
 * @returns {string}
 */
export const getImportErrors = importId => `${BASE_URI_DEVELOPMENT_CENTER}/imports/${importId}/failed-rows/export`;
